"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.selectedAccountIdSelector = exports.mainAccountSelector = exports.isFuturesEnabledSelector = exports.isFuturesActiveSelector = exports.futuresSystemEnabledSelector = exports.futuresMidPriceSelector = exports.futuresMarkPriceSelector = exports.futuresLevel1StateSelector = exports.futuresLevel1DataSelector = exports.futuresLastPriceSelector = exports.futuresKVPInfoSelector = exports.futuresIndexPriceSelector = exports.futuresEnabledSelector = exports.futuresContractDetailsSelector = exports.futuresBalancesSelector = exports.futuresBalancesLoadingSelector = exports.futuresAccountSelector = exports.futuresAccountMaxQuantitySelector = exports.futuresAccountInfoSelector = exports.futuresAccountIdSelector = exports.accountsSelector = void 0;
var _reselect = require("reselect");
var _futuresInstrumentsSelector = require("./futuresInstrumentsSelector");
var selectFuturesState = function selectFuturesState(state) {
  return state.futures;
};

// Checks whether the Operator + User has futures capability.
var isFuturesEnabledSelector = exports.isFuturesEnabledSelector = (0, _reselect.createSelector)(function (state) {
  return state.user.userInfo;
}, function (state) {
  return state.user.accounts;
}, function (userInfo, accounts) {
  return !!userInfo.FuturesBorrowerEnabled && accounts.some(function (account) {
    return account.AccountType === 'Futures';
  });
});
var futuresAccountSelector = exports.futuresAccountSelector = (0, _reselect.createSelector)(function (state) {
  return state.user.accounts;
}, function (accounts) {
  return accounts.find(function (account) {
    return account.AccountType === 'Futures';
  });
});
var futuresAccountIdSelector = exports.futuresAccountIdSelector = (0, _reselect.createSelector)(futuresAccountSelector, function (futuresAccount) {
  return futuresAccount === null || futuresAccount === void 0 ? void 0 : futuresAccount.AccountId;
});
var accountsSelector = exports.accountsSelector = (0, _reselect.createSelector)(function (state) {
  return state.user.accounts;
}, function (accounts) {
  return accounts;
});
var mainAccountSelector = exports.mainAccountSelector = (0, _reselect.createSelector)(function (state) {
  return state.user.accounts;
}, function (accounts) {
  var assetAccounts = accounts.filter(function (account) {
    return account.AccountType === 'Asset';
  });
  return assetAccounts.length ? assetAccounts.sort(function (a, b) {
    return a.AccountId - b.AccountId;
  })[0] : null;
});
var selectedAccountIdSelector = exports.selectedAccountIdSelector = (0, _reselect.createSelector)(function (state) {
  return state.user.selectedAccountId;
}, function (selectedAccountId) {
  return selectedAccountId;
});
var isFuturesActiveSelector = exports.isFuturesActiveSelector = (0, _reselect.createSelector)(futuresAccountSelector, selectedAccountIdSelector, function (futuresAccount, selectedAccountId) {
  return selectedAccountId && (futuresAccount === null || futuresAccount === void 0 ? void 0 : futuresAccount.AccountId) === selectedAccountId;
});
var futuresSystemEnabledSelector = exports.futuresSystemEnabledSelector = function futuresSystemEnabledSelector(state) {
  return selectFuturesState(state).systemFuturesEnabled;
};
var futuresAccountInfoSelector = exports.futuresAccountInfoSelector = function futuresAccountInfoSelector(state) {
  return selectFuturesState(state).accountInfo;
};
var futuresEnabledSelector = exports.futuresEnabledSelector = function futuresEnabledSelector(state) {
  return state.user.userInfo.FuturesEnabled;
};
var futuresKVPInfoSelector = exports.futuresKVPInfoSelector = function futuresKVPInfoSelector(state) {
  return selectFuturesState(state).futuresKVPInfo;
};
var futuresContractDetailsSelector = exports.futuresContractDetailsSelector = function futuresContractDetailsSelector(state) {
  return selectFuturesState(state).contractDetails;
};
var futuresAccountMaxQuantitySelector = exports.futuresAccountMaxQuantitySelector = function futuresAccountMaxQuantitySelector(state) {
  return selectFuturesState(state).accountMaxQuantity.maxQuantity.MaxAmount;
};
var futuresLevel1StateSelector = exports.futuresLevel1StateSelector = function futuresLevel1StateSelector(state) {
  return selectFuturesState(state).level1;
};
var futuresLevel1DataSelector = exports.futuresLevel1DataSelector = (0, _reselect.createSelector)([futuresLevel1StateSelector, _futuresInstrumentsSelector.futuresSelectedInstrumentIdSelector], function (state, instrumentId) {
  return state.level1[instrumentId];
});
var futuresMidPriceSelector = exports.futuresMidPriceSelector = (0, _reselect.createSelector)(futuresLevel1DataSelector, function (level1Data) {
  return level1Data ? (level1Data.BestBid + level1Data.BestAsk) / 2 : 0;
});
var futuresMarkPriceSelector = exports.futuresMarkPriceSelector = (0, _reselect.createSelector)(futuresLevel1DataSelector, function (level1Data) {
  var _level1Data$MarkPrice;
  return (_level1Data$MarkPrice = level1Data === null || level1Data === void 0 ? void 0 : level1Data.MarkPrice) !== null && _level1Data$MarkPrice !== void 0 ? _level1Data$MarkPrice : 0;
});
var futuresIndexPriceSelector = exports.futuresIndexPriceSelector = (0, _reselect.createSelector)(futuresLevel1DataSelector, function (level1Data) {
  var _level1Data$IndexPric;
  return (_level1Data$IndexPric = level1Data === null || level1Data === void 0 ? void 0 : level1Data.IndexPrice) !== null && _level1Data$IndexPric !== void 0 ? _level1Data$IndexPric : 0;
});
var futuresLastPriceSelector = exports.futuresLastPriceSelector = (0, _reselect.createSelector)(futuresLevel1DataSelector, function (level1Data) {
  var _level1Data$LastTrade;
  return (_level1Data$LastTrade = level1Data === null || level1Data === void 0 ? void 0 : level1Data.LastTradedPx) !== null && _level1Data$LastTrade !== void 0 ? _level1Data$LastTrade : 0;
});
var futuresBalancesState = function futuresBalancesState(state) {
  return selectFuturesState(state).balances;
};
var futuresBalancesSelector = exports.futuresBalancesSelector = function futuresBalancesSelector(state) {
  return selectFuturesState(state).balances;
};
var futuresBalancesLoadingSelector = exports.futuresBalancesLoadingSelector = function futuresBalancesLoadingSelector(state) {
  return futuresBalancesState(state).fetching;
};